import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

export default function InteractionWarningsView(props: { warnings: string[] }) {
  const { warnings } = { ...props };

  const warningsMapped = warnings.map((warning) => {
    return (
      <li
        key={warning}
        className={
          "list-disc whitespace-normal break-words [overflow-wrap:anywhere] text-[13px] leading-5 text-creator-text-sub"
        }
      >
        {warning}
      </li>
    );
  });
  return (
    <div
      className={
        "w-full min-w-0 max-w-full overflow-hidden p-2.5 flex flex-col gap-1.5 rounded-[5px] border border-solid border-[var(--pi-key-yellow)] bg-[var(--pi-key-yellow-faded)]"
      }
    >
      <div className={"text-[var(--pi-key-yellow)] flex items-center gap-1.5"}>
        <WarningAmberOutlinedIcon sx={{ fontSize: 16 }} color={"inherit"} />
        <div className={"text-[12px] font-semibold uppercase tracking-wide"}>
          Warning
        </div>
      </div>
      <ul className={"min-w-0 max-w-full pl-4"}>{warningsMapped}</ul>
    </div>
  );
}
